import { Box } from "@mui/material";
import {
  GridColDef,
  GridPagination,
  GridSlotsComponentsProps,
} from "@mui/x-data-grid";

export interface DataTableFooterProps {
  columns: GridColDef[];
  rows: any[];
  toolbarActions?: React.ReactNode;
}

const DataTableFooter: React.FC<
  DataTableFooterProps & GridSlotsComponentsProps
> = ({ rows, columns, toolbarActions }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid rgba(224, 224, 224, 1)",
      }}
    >
      <GridPagination />
      {toolbarActions && (
        <Box sx={{ display: "flex", gap: 1, mr: 2 }}>
          {toolbarActions}
        </Box>
      )}
    </Box>
  );
};

export default DataTableFooter;
